import _ from 'lodash/fp'
import { createReducer, createTypes, createActions } from '@fe/redux/reducers/util'

const namespace = 'guidesData'

const typeKeys = [
  'LOAD_REQUEST',
  'LOAD_SUCCESS',
  'LOAD_ERROR',

  'SAVE_DISTANCES_REQUEST', // guideId, holeId, distances
  'SAVE_DISTANCES_SUCCESS',
  'SAVE_DISTANCES_ERROR',
  'SAVE_DISTANCES_WAITING',

  'DELETE_DISTANCES_REQUEST', // guideId
  'DELETE_DISTANCES_SUCCESS',
  'DELETE_DISTANCES_ERROR',
  'DELETE_DISTANCES_WAITING',
  'DELETE_DISTANCES_RESET',

  'IMPORT_DISTANCES_REQUEST',   // { targetGuideId, sourceGuideId, deleteExisting }
  'IMPORT_DISTANCES_SUCCESS',
  'IMPORT_DISTANCES_ERROR',
  'IMPORT_DISTANCES_WAITING',
  'IMPORT_DISTANCES_RESET'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

const initialState = {
  items: {},
  saveWaiting: false,
  importWaiting: false,
  importSuccess: null,
  deleteWaiting: false,
  deleteSuccess: null
}

const reducer = {
  [types.SAVE_DISTANCES_WAITING]: _.set('saveWaiting'),
  [types.DELETE_DISTANCES_WAITING]: _.set('deleteWaiting'),
  [types.DELETE_DISTANCES_REQUEST]: () => _.set('deleteSuccess', null),
  [types.LOAD_SUCCESS]: p => _.setWith(Object, `items.${_.get('guideId', p)}`, p),
  [types.SAVE_DISTANCES_SUCCESS]: p => {
    const holeId = _.get('0.holeId', p)
    const guideId = _.get('0.guideId', p)
    if (!holeId || !guideId) {
      return _.identity
    }
    return _.update(`items.${guideId}.holes`, _.map(hole => {
      if (hole.holeId !== holeId) {
        return hole
      } else {
        return _.set('drawingData.distances', p, hole)
      }
    }))
  },
  [types.DELETE_DISTANCES_SUCCESS]: guideId => _.flow(
    _.update(`items.${guideId}.holes`, _.map(hole => _.set('drawingData.distances', [], hole))),
    _.set('deleteSuccess', true)
  ),
  [types.DELETE_DISTANCES_ERROR]: () => _.set('deleteSuccess', false),
  [types.DELETE_DISTANCES_RESET]: () => _.set('deleteSuccess', null),
  [types.IMPORT_DISTANCES_WAITING]: _.set('importWaiting'),
  [types.IMPORT_DISTANCES_REQUEST]: () => _.set('importSuccess', null),
  [types.IMPORT_DISTANCES_SUCCESS]: () => _.set('importSuccess', true),
  [types.IMPORT_DISTANCES_ERROR]: () => _.set('importSuccess', false),
  [types.IMPORT_DISTANCES_RESET]: () => _.set('importSuccess', null),
}

function createSelectors () {
  const guidesData = _.get(`${namespace}.items`)
  const guideData = guideId => _.flow(
    guidesData,
    _.get(guideId),
    guideData => {
      if (!guideData) {
        return null
      } else {
        return _.update('holes', _.map(hole => {
          // Only set overrideImage if drawingData already exists to avoid creating incomplete structures
          if (_.get('drawingData', hole)) {
            return _.set('drawingData.overrideImage', null, hole)
          }
          return hole
        }), guideData)
      }
    }
  )
  const saveDistancesWaiting = _.get(`${namespace}.saveWaiting`)
  const deleteDistancesWaiting = _.get(`${namespace}.deleteWaiting`)
  const deleteDistancesSuccess = _.get(`${namespace}.deleteSuccess`)
  const importDistancesWaiting = _.get(`${namespace}.importWaiting`)
  const importDistancesSuccess = _.get(`${namespace}.importSuccess`)
  return {
    guidesData,
    guideData,
    saveDistancesWaiting,
    deleteDistancesWaiting,
    deleteDistancesSuccess,
    importDistancesWaiting,
    importDistancesSuccess
  }
}

export const selectors = createSelectors()

export default createReducer(initialState, reducer)
